exports = module.exports = require("../../../node_modules/@zxcabs/rtl-css-loader/lib/css-base.js")();
// imports
exports.i(require("-!../../../node_modules/@zxcabs/rtl-css-loader/index.js?dirTagName=body&diff=true!vue-slider-component/theme/default.css"), "");

// module
exports.push([module.id, ".merge-tooltip{position:absolute;left:50%;bottom:100%;transform:translate(-50%,-15px);background-color:transparent;color:#000;border-color:transparent;margin-bottom:-7px}body[dir=rtl] .merge-tooltip {\n  right: 50%;\n  transform: translate(50%,-15px);\n}\n", ""]);

// exports
